var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*
    This file is generated with the "identicons" script.
    To update this output make changes to `scripts/svgr/identicon-icon-template.js
    */
import * as React from 'react';
import { IdenticonsCustomProperty, useColorMap, identiconComponentName } from '../common';
import { styled } from '../../styled';
export var IdenticonActivity = styled(function (_a) {
    var color = _a.color, props = __rest(_a, ["color"]);
    var colorMap = useColorMap({
        color: color,
    });
    var fills = {
        light: "var(".concat(IdenticonsCustomProperty.light, ", ").concat(colorMap.light, ")"),
        base: "var(".concat(IdenticonsCustomProperty.base, ", ").concat(colorMap.base, ")"),
        dark: "var(".concat(IdenticonsCustomProperty.dark, ", ").concat(colorMap.dark, ")"),
    };
    return (React.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 48 48", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M6.003 8h35.934a4.003 4.003 0 014.004 4.003v23.994A4.003 4.003 0 0141.937 40H6.003A4.003 4.003 0 012 35.997V12.003A4.003 4.003 0 016.003 8z", fill: fills.light }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M38.538 15.533c.634.664.61 1.717-.054 2.353L26.67 29.16a1.663 1.663 0 01-2.298 0l-5.084-4.854-7.437 6.902a1.663 1.663 0 01-2.263-2.437l8.586-7.966a1.663 1.663 0 012.28.016l5.067 4.84 10.665-10.18a1.661 1.661 0 012.352.051z", fill: fills.dark }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M29.145 16.047a1.663 1.663 0 011.538-1.027h6.654c.919 0 1.663.744 1.663 1.662v6.655a1.666 1.666 0 01-2.84 1.178l-6.655-6.655a1.667 1.667 0 01-.36-1.813z", fill: fills.dark })));
}, {
    name: identiconComponentName,
})({});
